<template>
  <v-dialog v-model="dialog" persistent max-width="900px">
    <v-card>
      <v-card-title>
        <span class="headline">Выбор сотрудников</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md class="pa-0">

          <v-layout wrap>
            <v-flex xs6>
              <v-card-text class="contractor-picker-tree">
                <v-treeview
                        v-model="selectedNodes"
                        :items="companyTree"
                        activatable
                        active-class="grey lighten-4 indigo--text"
                        selected-color="indigo"
                        open-all
                        open-on-click
                        selectable
                        expand-icon="mdi-chevron-down"
                        on-icon="mdi-account-box"
                        off-icon="mdi-account"
                        indeterminate-icon="mdi-bookmark-minus"
                >
                </v-treeview>
              </v-card-text>
            </v-flex>

            <v-flex xs6>

              <v-card-text>
                <div
                        v-if="selectedPosts.length === 0"
                        key="title"
                        class="title font-weight-light grey--text pa-3 text-xs-center"
                >
                  Выберите исполнителей задачи
                </div>

                <v-scroll-x-transition
                        group
                        hide-on-leave
                >
                  <v-chip
                          v-for="(selection, i) in selectedPosts"
                          :key="i"
                          color="grey"
                          dark
                          small
                  >
                    <v-icon left small>mdi-account-circle</v-icon>
                    {{ selection.name }}
                    <v-icon right small @click="onDeletePost( selection.id )">close</v-icon>
                  </v-chip>
                </v-scroll-x-transition>
              </v-card-text>

            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="secondary" @click="dialog = false">Отменить</v-btn>
        <v-btn class="primary" @click="ok()">Выбрать</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  /**
   *
   *
   */
  export default {

    name: 'ContractorPicker',

    /**
     * Внешние данные компонента.
     *
     */
    props: {

      // Выбранные элементы дерева.
      selected: {
        type: Array,
        required: false,
        default: []
      }
    },

    /**
     * Операционные данные.
     *
     */
    data() {

      return {

        dialog: false,

        // Дерево оргструктуры компании.
        companyTree: [],

        // Выделенные в дереве узлы.
        selectedNodes: [],

        // Сотрудники компании.
        posts: [],

        // Выбранные сотрудники компании.
        selectedPosts: [],



        usersList: [],
        filterSource: []
      }
    },

    /**
     *
     *
     */
    watch: {

      /**
       *
       *
       */
      selected: {

        handler( list ) {
          this.selectedNodes = list
        },

        immediate: true
      },

      /**
       *
       *
       */
      companyTree ( tree ) {

        this.filterSource = tree
        this.recursus( this.filterSource )

        this.$store.dispatch( 'app/anketa/orgschemeForms', { posts_ids: this.usersList } ).then( posts => {
          this.addPostInfo( this.filterSource, posts )
          this.getItems( tree )
        } )

        console.log( 'tree >>> ', tree )

        if ( !tree ) {
          return
        }
      },

      /**
       *
       *
       */
      selectedNodes( list ) {

        this.selectedPosts = []
        list.forEach( ( id ) => {

          let card = this.posts.find( post => post.id === id )

          if ( card ) {
            this.selectedPosts.push( card )
          }

        } )
      }
    },

    /**
     *
     *
     */
    computed: {

    },

    /**
     *
     *
     */
    methods: {

      /**
       *
       *
       */
      show() {
        this.getTrees()
        this.dialog = true
      },

      /**
       *
       *
       */
      hide() {
        this.dialog = false
      },

      /**
       *
       *
       */
      ok() {
        this.dialog = false
        this.$emit( 'ok', this.selectedPosts )
      },

      /**
       *
       *
       */
      getTrees() {
        this.$store.dispatch( 'app/org/tree', 'other' ).then( usersTree => {
          this.companyTree = usersTree
        } )
      },

      /**
       *
       *
       * @param tree
       */
      getItems( tree ) {

        tree.forEach( ( post ) => {

          if ( post.element_type === 'post' ) {
            this.posts.push( {
              id: post.id,
              postName: post.post_name,
              userName: post.fullname,
              name: post.name,
              photo: post.photo
            } )
          }

          if ( Array.isArray( post.children ) ) {
            this.getItems( post.children )
          }
        } );
      },

      /**
       *
       *
       * @param id
       */
      onDeletePost( id ) {

        console.log( `selectedPostId >>> `, id )

        let index = this.selectedNodes.findIndex( postId => postId === id )

        console.log( `selectedPostIndex >>> `, index )

        if ( index !== -1 ) {
          this.selectedNodes.splice( index, 1 )
        }
      },

      /**
       *
       *
       * @param tree
       */
      recursus( tree ) {

        tree.forEach( ( leaf ) => {

          if ( leaf.element_type === 'post' ) {
            if ( leaf.account_id !== null ) {
              this.usersList.push( leaf.id )
            }
          }
          else if ( leaf.element_type === 'container' ) {
            this.recursus( leaf.children )
          }
        } )
      },

      /**
       *
       *
       * @param tree
       * @param posts
       */
      addPostInfo( tree, posts ) {

        tree.forEach( ( leaf, index ) => {

          if ( leaf.element_type === 'post' ) {
            if ( leaf.account_id !== null ) {
              leaf.fullname = posts[ leaf.id ].fullname
              leaf.post_name = leaf.name
              leaf.name = `${leaf.name} / ${leaf.fullname}`
              leaf.photo = posts[ leaf.id ].photo
            }
          }
          else if ( leaf.element_type === 'container' ) {
            this.addPostInfo( leaf.children, posts )
          }
        } )
      }
    }
  }

</script>

<style>

  .contractor-picker-tree {
    border: 1px dashed #aaa;
    height: 400px;
    overflow: auto;
  }

</style>



// WEBPACK FOOTER //
// src/apps/bpm/components/ContractorPicker.vue